<div *ngIf="!faq.editMode">
  <div class="faq-block">
    <div class="faq-question">
      <span>{{ faq.question }}</span>
      <button class="faq-right" mat-icon-button (click)="faq.expanded = !faq.expanded" *ngIf="!faq.expanded">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <button class="faq-right" mat-icon-button (click)="faq.expanded = !faq.expanded" *ngIf="faq.expanded">
        <mat-icon>arrow_drop_up</mat-icon>
      </button>
    </div>
    <div class="faq-answer" *ngIf="faq.expanded">
      <p [class.showAll]="showMore" #clampTxt>
        {{ faq.answer }}
      </p>
      <button
        mat-button
        *ngIf="clampTxt.scrollHeight > clampTxt.clientHeight && !showMore"
        class="txt-button"
        (click)="showMore = true"
      >
        {{ 'recordsSearch.more' | xTranslate }}
      </button>
    </div>
    <div class="thumbs-up">
      <button mat-button [class.liked]="faq.liked" (click)="likeFaqEvent.emit(faq.id)">
        <mat-icon>thumb_up</mat-icon> <span>{{ faq.numberOfLikes }} </span>
      </button>
    </div>
  </div>
</div>

<div *ngIf="faq.editMode">
  <div class="create-service">
    <form [formGroup]="faqFormGroup">
      <div class="flex-grid">
        <div class="col">
          <mat-form-field
            appearance="outline"
            class="issue-title-input"
            [ngClass]="{
              errorMessage:
                faqFormGroup.controls.question.errors?.required || faqFormGroup.controls.question.errors?.maxlength,
            }"
          >
            <input
              matInput
              autocomplete="no-autofill"
              placeholder="{{ 'core.issueTitle' | xTranslate }}"
              formControlName="question"
              (blur)="onFaqChange()"
            />
            <mat-error class="text-error" *ngIf="faqFormGroup.controls.question.errors?.required">
              {{ 'core.titleRequired' | xTranslate }}
            </mat-error>
            <mat-error *ngIf="faqFormGroup.controls.question.errors?.maxlength">
              {{ 'core.titleSizeLimit' | xTranslate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="issue-description-input">
            <textarea
              matInput
              autocomplete="no-autofill"
              placeholder="{{ 'core.issueDesc' | xTranslate }}"
              formControlName="answer"
              (blur)="onFaqChange()"
            ></textarea>
            <mat-error class="textarea-error" *ngIf="faqFormGroup.controls['answer'].errors?.required">
              {{ 'core.shotDescReq' | xTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <div class="thumb-align">
    <span class="thumbs-up-disabled">
      <button disabled="true" mat-icon-button>
        <mat-icon>thumb_up</mat-icon> <span> {{ faq.numberOfLikes }}</span>
      </button>
    </span>
    <span>
      <button (click)="deleteFaqEvent.emit(faq)" mat-icon-button>
        <mat-icon class="mat-icon-delete" svgIcon="trash-icon"></mat-icon>
      </button>
    </span>
  </div>
</div>
